export { ResourcesSubmenu } from './ResourcesSubmenu';
